import styled from '@emotion/styled';

import { ScreenName } from '../../../../../shared/amplitude';
import { useScreenName } from '../../../../../shared/hooks';

import { ProductReview } from '../../ProductReview.service';
import { ReviewContentGrid } from './styled-components';
import { BackToList } from '../ReviewGallery/styled-components';
import { List, Next, Previous } from '../../../../../shared/icons';
import ReviewModalImagContent from './ReviewModalImagContent';
import ReviewModalPostContent from './ReviewModalPostContent';
import ReviewModalImageSkeleton from './ReviewModalImageSkeleton';
import ReviewModalPostSkeleton from './ReviewModalPostSkeleton';
import { useDirectionKey } from '../../../../../shared/hooks/useDirectionKey';

const PrevButton = styled.button`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
`;

const NextButton = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
`;

interface Props {
  review?: ProductReview;
  onClickPrev(): void;
  onClickNext(): void;
  onClickBackToList(): void;
}

export default function ReviewModalDetailContent({ review, onClickNext, onClickPrev, onClickBackToList }: Props) {
  useScreenName(ScreenName.PRODUCT_REVIEW_DETAIL);
  useDirectionKey({
    rightKeyAction: onClickNext,
    leftKeyAction: onClickPrev,
  });

  const renderContent = () => {
    if (!review) {
      return (
        <ReviewContentGrid>
          <ReviewModalImageSkeleton />
          <ReviewModalPostSkeleton />
        </ReviewContentGrid>
      );
    }

    const { images, likeCount } = review;

    return (
      <ReviewContentGrid>
        <ReviewModalImagContent images={images} />
        <ReviewModalPostContent key={likeCount} reviewType="IMAGE" {...review} />
        <div>
          <BackToList onClick={onClickBackToList}>
            <List />
            사진 목록 보기
          </BackToList>
        </div>
      </ReviewContentGrid>
    );
  };
  return (
    <>
      {renderContent()}
      <PrevButton type="button" value="prev" onClick={onClickPrev}>
        <Previous />
      </PrevButton>
      <NextButton type="button" value="next" onClick={onClickNext}>
        <Next />
      </NextButton>
    </>
  );
}
